import { Button, ConfigProvider, Form, Input, Modal, Radio, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { listSandboxKeys } from "../../services/account/api";
import { useLayoutEffect, useState } from "react";
import { useAuth } from "../../contexts/auth";
import API from "../../library/helpers/api";
import { CaptureSVG } from "./CaptureSVG";
import { FormattedMessage } from "react-intl";
import { loadState, saveState } from "../../library/helpers/localStorage";
import "./styles.css";

export function PreCaptureInformationDialog({ open, onCancel }) {
  const { user, workspaceId } = useAuth();

  const uuid = crypto.randomUUID();

  const [primaryColor, setPrimaryColor] = useState("#00ABAB");
  const [captureKey, setCaptureKey] = useState();
  const [email, setEmail] = useState(loadState("testCaptureUserIdentifier") ?? user.email);
  const [transactionType, setTransactionType] = useState(loadState("testCaptureTransactionType") ?? "verification");
  const [endToEndId, setEndToEndId] = useState(uuid);
  const [isLoading, setLoading] = useState(true);

  useLayoutEffect(() => {
    Promise.all([
      listSandboxKeys(workspaceId).then((res) => {
        setCaptureKey(res.capture_key);

        API.getSettings(res.capture_key)
        .then((res) => res.data.message)
        .then((data) => {
          setPrimaryColor(data.primary_color);
        });
      }),
    ]).finally(() => setLoading(false));
  });

  const startNewCapture = async () => {
    onCancel();

    setTimeout(() => {
        window.GoSaffe.init(captureKey, email, endToEndId, transactionType);
    }, 30);

  };

  return (
    <ConfigProvider
      theme={{
        token: { colorPrimary: primaryColor},
        components: {
          Form: {
            marginLG: 15,
          },
          Modal: {
            motionDurationMid: '0.15s',
            motionDurationSlow: '0.15s',
          },
        },
      }}
    >
      <Modal
        rootClassName="pre-capture"
        centered
        destroyOnClose
        open={open}
        onOk={onCancel}
        onCancel={onCancel}
        width={480}
        footer={null}
        closeIcon={<div className="close"/>}
        mousePosition={{ x: '50%'}}
      >
        <div className="pt-4">
          {isLoading ? (
            <div className="flex justify-center items-center">
              <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: 50 }} spin />} />
            </div>
          ) : (
              <>
            <div className="overflow-x-hidden overflow-y-auto">
                <div className="flex items-center justify-center sm:w-72 w-full mx-auto">
                  <CaptureSVG color={primaryColor} />
                </div>
                <Form layout="vertical" className="gap-5">
                  <Form.Item
                    required
                    label={<FormattedMessage id="capture_key" />}
                  >
                    <Input size="large" value={captureKey} disabled />
                  </Form.Item>
                  <Form.Item
                    required
                    label={<FormattedMessage id="identifier" />}
                  >
                    <Input
                      size="large"
                      value={email}
                      onChange={(e) => {
                        saveState("testCaptureUserIdentifier", e.target.value);
                        setEmail(e.target.value);
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    required
                    label={<FormattedMessage id="transaction_type" />}
                  >
                    <div className="flex items-center">
                      <Radio.Group
                        size="large"
                        value={transactionType}
                        onChange={(e) => {
                          saveState("testCaptureTransactionType", e.target.value);
                          setTransactionType(e.target.value);
                        }}
                        buttonStyle="solid"
                        className="w-full"
                      >
                        <Radio.Button
                          className="w-1/2 text-center"
                          value="verification"
                          onChange={(e) => {
                            saveState("testCaptureTransactionType", e.target.value);
                            setTransactionType(e.target.value);
                          }}
                        >
                          <FormattedMessage id={"verification"} />
                        </Radio.Button>
                        <Radio.Button
                          className="w-1/2 text-center"
                          value="onboarding"
                        >
                          <FormattedMessage id={"onboarding"} />
                        </Radio.Button>
                      </Radio.Group>
                    </div>
                  </Form.Item>
                  <Form.Item required label="End to end ID">
                    <Input
                      size="large"
                      value={endToEndId}
                      onChange={(e) => setEndToEndId(e.target.value)}
                    />
                  </Form.Item>
                </Form>
              </div>
              <div className="py-3 z-50 flex justify-center sticky bottom-0 w-full bg-white">
                <Button
                  className="!px-[30px] min-h-[38px] shadow-none"
                  shape="round"
                  type="primary"
                  disabled={!endToEndId || !email}
                  style={{ background: primaryColor }}
                  onClick={startNewCapture}
                >
                  <FormattedMessage id={"start_capture"} />
                </Button>
              </div>
              </>
          )}
        </div>
      </Modal>
    </ConfigProvider>
  );
}
